import RGBA from '../Fonts/RGBA'

let gray = new RGBA(255,255,255,.2);
let grayFromDark = new RGBA(0, 0, 0,.2);
let white = new RGBA(255);
let blue = new RGBA(9,99,152);
let darkBlue = new RGBA(22, 34, 75);
let red = new RGBA(255, 0, 0);
let none = null;

let styles = {

  'transparent': {

    'default' : {
      circle : gray,
      arrow : gray,
      background : none
    },
    'hover' : {
      circle : none,
      arrow : blue,
      background : white
    },


  },

  'dark': {

    'default' : {
      circle : gray,
      arrow : gray,
      background : none
    },
    'hover' : {
      circle : none,
      arrow : darkBlue,
      background : white
    },


  },

  'white': {

    'default' : {
      circle : grayFromDark,
      arrow : grayFromDark,
      background : none
    },

    'hover' : {
      circle : none,
      arrow : white,
      background : blue
    }

  }

};

let size = 30;





export default class Arrow
{

  constructor(scaleFactor) {
    this.scaleFactor = scaleFactor;
  }

  scale(n) {
    return Math.floor(this.scaleFactor * n);
  }

  setScaleFactor(scaleFactor) {
    this.scaleFactor = scaleFactor;
  }

  draw(ctx, x, y, direction, hover, styleName)
  {

    let style = styles[styleName][hover ? 'hover' : 'default'];

    ctx.save();

    ctx.beginPath();
    if (style.background || style.circle) {
      this.drawCircleOn(ctx, x, y, size);

      if (style.background) {
        ctx.fillStyle = style.background;
        ctx.fill();
      }
      if (style.circle) {
        ctx.lineWidth = this.scale(1);
        ctx.strokeStyle = style.circle;
        ctx.stroke();
      }

    }

    if (style.arrow) {

      this.drawInsideOn(ctx, x, y, size, direction);

      ctx.lineCap = 'round';
      ctx.lineWidth = this.scale(2);
      ctx.strokeStyle = style.arrow;
      ctx.stroke();

    }

    ctx.restore();

  }














  drawOn(ctx, x, y, size, direction)
  {

    // this.drawCircleOn(ctx, x, y, size);
    // this.drawInsideOn(ctx, x, y, size, direction);

  }

  drawCircleOn(ctx, x, y, size)
  {

    ctx.beginPath();
    ctx.arc(this.scale(x + size / 2), this.scale(y + size / 2), this.scale(size / 2), 0, Math.PI * 2);

  }

  drawInsideOn(ctx, x, y, size, direction)
  {

    ctx.beginPath();

    let box = {
      width: 10,
      height: 10
    };

    box.x = x + (size - box.width) / 2;
    box.y = y + (size - box.height) / 2;

    ctx.moveTo(this.scale(box.x), this.scale(box.y + box.height / 2));
    ctx.lineTo(this.scale(box.x + box.width), this.scale(box.y + box.height / 2));

    if (direction === 'right') {
      ctx.moveTo(this.scale(box.x + box.width - box.height / 2), this.scale(box.y));
      ctx.lineTo(this.scale(box.x + box.width), this.scale(box.y + box.height / 2));
      ctx.lineTo(this.scale(box.x + box.width - box.height / 2), this.scale(box.y + box.height));
      return;
    }

    ctx.moveTo(this.scale(box.x + box.height / 2), this.scale(box.y));
    ctx.lineTo(this.scale(box.x), this.scale(box.y + box.height / 2));
    ctx.lineTo(this.scale(box.x + box.height / 2), this.scale(box.y + box.height));

  }

  fillAndStrokeOn(ctx, fillStle, strokeStyle)
  {

    if (fillStle) {
      ctx.fillStyle = fillStle;
      ctx.fill();
    }

    if (strokeStyle) {
      ctx.strokeStyle = strokeStyle;
      ctx.stroke();
    }

  }


}
